import React from "react";
import Router from "../../router/router";
import Wrap from "../../components/wrapper/";

export default function Main() {
  return (
    <Wrap>
      <Router />
    </Wrap>
  );
}
